import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/motion/Reveal";

// Partners — add new entries here; cards render in order.
// `relationship` lists each side of the partnership as short pills.
const PARTNERS = [
  {
    name: "BarCamp Hua Hin",
    tagline: "Monthly tech & design unconference",
    url: "https://www.barcamphuahin.com/",
    urlLabel: "barcamphuahin.com",
    logo: "/barcamp-hua-hin-logo.png",
    logoBg: "#d93132",
    description:
      "BarCamp Hua Hin is a community-driven unconference held every last Saturday at The Hub Hua Hin, Thailand. Open-format talks, demos, and discussions on tech, design, AI, and ideas, where anyone can pitch a session and the room decides what happens next.",
    relationship: [
      {
        label: "We sponsor them",
        body: "Hayden Bulk Tech Labs is a proud sponsor of BarCamp Hua Hin, helping keep every edition free and open to the local creative and tech community.",
      },
      {
        label: "They host us",
        body: "BarCamp gives us a stage to share what we're building, meet founders and builders, and connect with the Hua Hin tech scene in person.",
      },
    ],
    location: "Hua Hin, Thailand",
  },
  {
    name: "The Hub Hua Hin",
    tagline: "Co-working & community hub",
    url: "https://thehubhuahin.com/",
    urlLabel: "thehubhuahin.com",
    logo: "/thehub-logo.svg",
    logoBg: "#ffffff",
    description:
      "The Hub Hua Hin is a modern co-working and community space in Hin Lek Fai, built for entrepreneurs, remote workers, and creatives who want a healthy balance of focus and play. It's the home of BarCamp Hua Hin.",
    relationship: [
      {
        label: "Where we show up",
        body: "The Hub is the venue behind BarCamp Hua Hin, the stage where we share what we're building and meet the local tech community each month.",
      },
      {
        label: "Building the scene together",
        body: "We share the same goal: a stronger tech and creative community in Hua Hin, with a real place for builders to meet.",
      },
    ],
    location: "Hin Lek Fai, Hua Hin",
  },
];

const PartnersPage = () => {
  return (
    <div className="partners-page">
      <div className="container">
        <Reveal className="section-header" mount>
          <p className="section-label">Partners</p>
          <h1>Who We Build With</h1>
          <p className="section-intro">
            Communities and companies we support, and who support us back.
          </p>
        </Reveal>

        <div className="partner-list">
          {PARTNERS.map((partner, i) => (
            <Reveal
              key={partner.name}
              className="partner-card"
              delay={i * 0.06}
            >
              <span className="product-index" aria-hidden="true">
                {String(i + 1).padStart(2, "0")}
                <small>/{String(PARTNERS.length).padStart(2, "0")}</small>
              </span>
              <a
                className="partner-logo"
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ background: partner.logoBg }}
                aria-label={`Visit ${partner.name}`}
              >
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  loading="lazy"
                />
              </a>
              <div className="partner-content">
                <h2>{partner.name}</h2>
                <p className="product-tagline">{partner.tagline}</p>
                <p className="product-desc">{partner.description}</p>

                <div className="partner-relationship">
                  {partner.relationship.map((item) => (
                    <div key={item.label} className="partner-role">
                      <h3>{item.label}</h3>
                      <p>{item.body}</p>
                    </div>
                  ))}
                </div>

                <div className="product-meta">
                  <a
                    className="btn btn-primary"
                    href={partner.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit {partner.urlLabel}
                  </a>
                  <span className="product-platform">
                    {partner.location}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="partner-cta">
          <h2>Want to partner with us?</h2>
          <p>
            We sponsor community events and team up with companies building
            ambitious products. Tell us what you have in mind.
          </p>
          <Link
            to="/"
            state={{ scrollTo: "contact" }}
            className="btn btn-primary"
          >
            Get in Touch
          </Link>
        </Reveal>
      </div>
    </div>
  );
};

export default PartnersPage;
